import './HamburgerMenu.css';
import HamburgerMenuItem from "./sub/HamburgerMenuItem/HamburgerMenuItem.jsx";

export default function HamburgerMenu({setDisplayHamburger,content,displayHamburger}) {
    return (
        <div
            id="hamburger-menu-wrapper"
            className={`hamburger-menu-wrapper${displayHamburger ? '--active' : '--inactive'}`}
            onClick={() => setDisplayHamburger(false)} // closes when wrapper clicked
        >
            <div
                id="hamburger-menu"
                className={`hamburger-menu${displayHamburger ? '--active' : '--inactive'}`}
                onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside menu
            >
                <div id="hamburger-menu-nav">
                    <div
                        id="hamburger-menu-close-bttn"
                        onClick={() => setDisplayHamburger(false)}
                    ></div>
                    <div id="hamburger-menu-nav-label-1">Menu</div>
                </div>
                <div id='hamburger-menu-content'>
                    {content.length>0 && content.map((item, index) => {
                        return <HamburgerMenuItem item={item} key={index} />
                    })}
                </div>
            </div>
        </div>
    );

}
